export function tryParseJSON<T>(value?: string | null): T | null {
  if (!value) return null

  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}
